
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vorur",
      function () {
        return require("private-next-pages/vorur.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vorur"])
      });
    }
  